<template>
  <div>
    <div class="wf-mt-3">
      <div class="wf-flex wf-justify-between wf-items-center">
        <h4 class="wf-text-xs wf-font-bold wf-uppercase wf-text-gray-500">Sections</h4>  
      </div>
    </div>
    <div class="wf-mt-3">
      <div class="wf-rounded-lg wf-bg-gray-200 wf-px-2 wf-py-4 wf-w-full wf-overflow-scroll wf-border" style="height: 250px">
        <div
          @click.prevent="addSection"
          class="wf-w-full wf-h-32 hover:wf-shadow-md wf-flex wf-items-center wf-shadow wf-justify-center wf-cursor-pointer wf-bg-white wf-rounded wf-mb-4"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
  import ArrayManipulation from '../../mixins/ArrayManipulation'
  import { SectionFactory } from '../../factories/SectionFactory'
  export default {
    mixins: [ArrayManipulation],
    computed: {
      toolbar: {
        get() {
          return this.$store.state.toolbar
        },
        set(value) {
          this.$store.commit('updateToolbar', value)
        }
      },
    },
    methods: {
      addSection() {
        this.addToArray('pageModule', (new SectionFactory).create(), 'sections')
        this.$store.commit('updateToolbar', false)
      },
    }
  }
</script>